"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_lazy_load_image_component_1 = require("react-lazy-load-image-component");
var classnames_1 = __importDefault(require("classnames"));
var Image = function (props) {
    var src = props.src, lazy = props.lazy, alt = props.alt, animate = props.animate, className = props.className, _a = props.width, width = _a === void 0 ? 'auto' : _a, _b = props.height, height = _b === void 0 ? 'auto' : _b, rest = __rest(props, ["src", "lazy", "alt", "animate", "className", "width", "height"]);
    var _c = (0, react_1.useState)(false), imageLoaded = _c[0], setImageLoaded = _c[1];
    var handleImgLoad = function () { return setImageLoaded(true); };
    /**
     * We need to set a height and width else all images will be in the viewport once
     * the page loads and thus all loaded at once. When a lazy image is wrapped in a
     * div, we can omit the width and height so that it occupies 100% of it's parent
     */
    if (lazy) {
        return (react_1.default.createElement(LazyImage, __assign({ alt: alt, src: src, width: width || '100%', height: height || '100%', className: (0, classnames_1.default)(className, { animate: animate, 'img-loaded': imageLoaded }), threshold: 350, onLoad: handleImgLoad }, rest)));
    }
    return (react_1.default.createElement(NormalImage, __assign({ src: src, alt: alt, className: (0, classnames_1.default)(className, { animate: animate, 'img-loaded': imageLoaded }), onLoad: handleImgLoad }, rest)));
};
exports.Image = Image;
var LazyImage = (0, styled_components_1.default)(react_lazy_load_image_component_1.LazyLoadImage)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.animate {\n    opacity: 0;\n    transition: 1s opacity ease;\n  }\n\n  &.animate.img-loaded {\n    opacity: 1;\n  }\n"], ["\n  &.animate {\n    opacity: 0;\n    transition: 1s opacity ease;\n  }\n\n  &.animate.img-loaded {\n    opacity: 1;\n  }\n"])));
var NormalImage = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.animate {\n    opacity: 0;\n    transition: 1s opacity ease;\n  }\n\n  &.animate.img-loaded {\n    opacity: 1;\n  }\n"], ["\n  &.animate {\n    opacity: 0;\n    transition: 1s opacity ease;\n  }\n\n  &.animate.img-loaded {\n    opacity: 1;\n  }\n"])));
exports.default = exports.Image;
var templateObject_1, templateObject_2;
